import React, { Fragment, useEffect, useState } from "react";
import { Text, View } from "react-native";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "../utils/convex-api";
import { Id } from "@teachloop/backend/_generated/dataModel";
import LessonHistorySubjectList from "./lesson-history-subject-list";
import { Button } from "../ui/button";
import { useRouter } from "expo-router";
import LessonHistoryItem from "./lesson-history-item";

function StudentLessonHistoryHome() {
  const { data: lessonHistorySubjects = [] } = useQuery(
    convexQuery(api.student.home.queries.getLessonReportSubjects, {})
  );
  const [firstSubject] = lessonHistorySubjects;
  const firstSubjectId = firstSubject?.id;
  const [selectedSubjectId, setSelectedSubjectId] =
    useState<Id<"subjects"> | null>(null);
  const { data: lessonReports = [] } = useQuery(
    convexQuery(
      api.student.home.queries.getLessonReports,
      selectedSubjectId
        ? {
            subjectId: selectedSubjectId,
          }
        : "skip"
    )
  );
  const router = useRouter();

  useEffect(() => {
    if (firstSubjectId && !selectedSubjectId) {
      setSelectedSubjectId(firstSubjectId);
    }
  }, [firstSubjectId, selectedSubjectId]);

  if (lessonHistorySubjects.length === 0) {
    return <Fragment />;
  }

  return (
    <View className="gap-4 mt-4">
      <Text className="font-geologica-medium font-medium text-[20px] text-gray-800 leading-[1.5]">
        Lesson history
      </Text>
      <LessonHistorySubjectList
        lessonHistorySubjects={lessonHistorySubjects}
        selectedSubjectId={selectedSubjectId}
        setSelectedSubjectId={setSelectedSubjectId}
      />
      <View>
        {lessonReports.slice(0, 3).map((item) => (
          <Fragment key={item._id}>
            <LessonHistoryItem item={item} />
            <View className="h-[1px] bg-gray-200" />
          </Fragment>
        ))}
      </View>
      <View className="items-end">
        {lessonReports.length > 3 && (
          <Button
            size="sm"
            outline
            className="border"
            onPress={() => {
              router.push("/(app)/home/lesson-history");
            }}
          >
            <Button.Text size="sm" intent="primary">
              See full history
            </Button.Text>
          </Button>
        )}
      </View>
    </View>
  );
}

export default StudentLessonHistoryHome;
